import * as React from 'react'


const OPTIONS = [
  ['natural-prefix', 'Natural prefix generation'],
  ['natural-suffix', 'Natural suffix generation'],
  ['common-words-prefix', 'Common prefix words'],
  ['common-words-suffix', 'Common suffix words'],
]


export default class AboutModal extends React.PureComponent<{
  onClose: () => void
}> {

  render() {
    const { onClose } = this.props

    return (
      <div className="modal about-modal">
        <div className="modal-content">

          <h1>Settings</h1>

          <button className="modal-close" onClick={onClose}>&times;</button>

          {OPTIONS.map(option =>
            <div>
              <input type="checkbox" value={option[0]} /> {option[1]}
            </div>
          )}

        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/settings-modal.tsx